module.exports = __webpack_public_path__ + "static/media/input-check.f0c8cd9b.svg";